import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import TRANSLATIONS_DATE_RANGE from './components/DateRangePicker/translations';
export var size = ['small'];
export var TRANSLATIONS = _objectSpread(_objectSpread({}, TRANSLATIONS_DATE_RANGE), {}, {
  choose: {
    en: 'Choose',
    ru: 'Выбрать'
  },
  chooseMonth: {
    en: 'Choose month',
    ru: 'Выберите месяц'
  },
  month: {
    en: 'Month',
    ru: 'Месяц'
  },
  range: {
    en: 'Exact dates',
    ru: 'Точные даты'
  },
  specifyDate: {
    en: 'Specify date',
    ru: 'Укажите период'
  }
});